var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",on:{"drop":function($event){$event.preventDefault();return _vm.onDrop($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }